var _rect, _g, _path, _path2, _g2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgSurgeryCostInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 106,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-35 -14C-35 -20.6274 -29.6274 -26 -23 -26H143C149.627 -26 155 -20.6274 155 -14V161.231C155 167.858 149.627 173.231 143 173.231H-23C-29.6274 173.231 -35 167.858 -35 161.231V-14Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 53.5C112 82.4949 88.4949 106 59.5 106C30.5051 106 7 82.4949 7 53.5C7 24.5051 30.5051 1 59.5 1C88.4949 1 112 24.5051 112 53.5Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_832",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 1,
    width: 105,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53.5C112 82.4949 88.4949 106 59.5 106C30.5051 106 7 82.4949 7 53.5C7 24.5051 30.5051 1 59.5 1C88.4949 1 112 24.5051 112 53.5Z",
    fill: "#D6E8F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5209 31.5C55.023 31.5 53.5398 31.7991 52.1559 32.3802C50.772 32.9612 49.5146 33.813 48.4554 34.8867L35.8276 47.6875C35.3782 48.143 35.0217 48.6838 34.7785 49.279C34.5353 49.8741 34.4102 50.512 34.4102 51.1562C34.4102 51.8005 34.5353 52.4384 34.7785 53.0335C35.0217 53.6287 35.3782 54.1695 35.8276 54.625C36.2769 55.0805 36.8104 55.4419 37.3975 55.6884C37.9846 55.9349 38.6139 56.0618 39.2494 56.0618C39.8849 56.0618 40.5142 55.9349 41.1013 55.6884C41.6885 55.4419 42.2219 55.0805 42.6713 54.625L55.2182 41.9062H67.7651L48.6512 61.282C48.2018 61.7375 47.8454 62.2783 47.6022 62.8734C47.359 63.4686 47.2338 64.1065 47.2338 64.7507C47.2338 65.3949 47.359 66.0328 47.6022 66.628C47.8454 67.2231 48.2018 67.7639 48.6512 68.2195C49.1006 68.675 49.634 69.0363 50.2212 69.2828C50.8083 69.5294 51.4375 69.6562 52.073 69.6562H52.1024C52.7287 69.6562 53.3488 69.531 53.9273 69.288C54.5058 69.045 55.0315 68.6888 55.4743 68.2398L55.4949 68.2189C55.0456 68.6744 54.6891 69.2152 54.4459 69.8104C54.2027 70.4055 54.0776 71.0434 54.0776 71.6876C54.0775 72.3319 54.2026 72.9698 54.4458 73.5651C54.6889 74.1603 55.0454 74.7012 55.4947 75.1567C55.9441 75.6123 56.4776 75.9737 57.0648 76.2203C57.6519 76.4668 58.2813 76.5938 58.9168 76.5938C59.5523 76.5938 60.1816 76.4669 60.7687 76.2203C61.3558 75.9738 61.8893 75.6125 62.3387 75.157L62.311 75.185C61.8705 75.6308 61.521 76.1602 61.2826 76.743C61.0441 77.3258 60.9214 77.9505 60.9213 78.5815V78.7311C60.9213 79.7019 61.2117 80.6499 61.7542 81.45C62.2967 82.25 63.0658 82.8645 63.9599 83.2123C64.8541 83.5601 65.8312 83.6249 66.7624 83.398C67.6936 83.1712 68.5351 82.6635 69.1757 81.9418L78.0307 71.9688H82.5932C84.3639 71.9688 86.1104 71.5508 87.6942 70.7481C89.278 69.9453 112.938 58.936 114 57.5L113.5 31.5H56.5209Z",
    fill: "#FF7D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7726 68.7285C54.3847 68.3353 54.3847 67.6979 54.7726 67.3047L63.9661 57.9852C64.354 57.5921 64.9828 57.5921 65.3707 57.9852L65.579 58.1964C65.9668 58.5895 65.9668 59.227 65.579 59.6202L56.3854 68.9396C55.9976 69.3328 55.3687 69.3328 54.9809 68.9396L54.7726 68.7285Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6134 75.666C61.2256 75.2728 61.2256 74.6354 61.6134 74.2422L70.8069 64.9227C71.1948 64.5296 71.8236 64.5296 72.2115 64.9227L72.4198 65.1339C72.8076 65.527 72.8076 66.1645 72.4198 66.5577L63.2263 75.8771C62.8384 76.2703 62.2096 76.2703 61.8217 75.8771L61.6134 75.666Z",
    fill: "#FF9D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4219 73.125L78.903 17.8976C79.3498 17.4446 79.8804 17.0853 80.4642 16.8401C81.0481 16.5949 81.6739 16.4687 82.3059 16.4688H82.3437C83.62 16.4688 84.8441 16.9827 85.7467 17.8976C86.6492 18.8125 87.1562 20.0534 87.1562 21.3473C87.1562 21.9989 87.0275 22.6439 86.7775 23.2442C86.5276 23.8445 86.1615 24.388 85.701 24.8426L43.8125 66.1875V71.9688L38.0523 77.8078C34.4373 81.4724 29.5343 83.5312 24.4219 83.5312V73.125Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7959 27.6987L75.4087 26.0638L77.6896 28.3759L76.0768 30.0108L73.7959 27.6987Z",
    fill: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.374 31.165L71.9869 29.5301L74.2677 31.8422L72.6549 33.4772L70.374 31.165Z",
    fill: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2178 24.2305L78.8306 22.5955L81.1115 24.9076L79.4986 26.5426L77.2178 24.2305Z",
    fill: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9521 34.6338L68.565 32.9988L70.8458 35.311L69.233 36.9459L66.9521 34.6338Z",
    fill: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5303 38.1016L65.1431 36.4666L67.424 38.7787L65.8111 40.4137L63.5303 38.1016Z",
    fill: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7021 53.1299L50.315 51.4949L52.5959 53.8071L50.983 55.442L48.7021 53.1299Z",
    fill: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2803 56.5962L46.8931 54.9613L49.174 57.2734L47.5611 58.9083L45.2803 56.5962Z",
    fill: "#D5D5D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2039 78.8466L27.4824 76.6526C29.5983 75.9402 31.552 74.8055 33.2283 73.3154L39.6388 67.6294L41.141 69.3698L34.7305 75.0557C32.8264 76.7483 30.6072 78.0372 28.2039 78.8466Z",
    fill: "#EAEAE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6406 41.9062C57.1281 41.9062 55.6775 42.5153 54.6079 43.5995C53.5384 44.6837 52.9375 46.1542 52.9375 47.6875C52.9375 49.2208 53.5384 50.6913 54.6079 51.7755C55.6775 52.8597 57.1281 53.4688 58.6406 53.4688H72.3281L74.633 56.0973C76.7778 58.5432 79.4092 60.5008 82.3541 61.8414C85.299 63.1819 95.7718 65.5 99 65.5L114.5 58.5L113.5 51L91.7188 41.9062H58.6406Z",
    fill: "#FF9D5A"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 6.27543C0.625 5.93148 0.916786 5.64485 1.2892 5.6341C1.40437 5.63051 12.4884 5.25789 18.9845 0.163032C19.2532 -0.0519407 19.6487 -0.0555235 19.9174 0.15945L19.9213 0.163032C26.4173 5.26148 37.4745 5.6341 37.5858 5.63768C37.9544 5.64843 38.25 5.93148 38.25 6.27902V6.32918C38.25 15.1861 36.6989 27.5685 29.0511 36.2427C24.4209 41.4952 19.8329 42.8782 19.6371 42.9355L19.4298 43L19.2148 42.9355C19.019 42.8782 14.4579 41.4952 9.82777 36.2427C2.17607 27.5649 0.625 15.1861 0.625 6.32559V6.27543Z",
    fill: "#E62645"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1985 21.0833L17.3649 25.0842C17.7522 25.4561 18.364 25.4557 18.7509 25.0834L27.8022 16.373C28.4562 15.7436 28.4562 14.6969 27.8022 14.0675C27.1828 13.4714 26.203 13.4714 25.5836 14.0675L18.055 21.3126L15.4146 18.776C14.7945 18.1803 13.8144 18.1814 13.1956 18.7786C12.5428 19.4086 12.5441 20.4549 13.1985 21.0833Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_832",
    x: -55,
    y: -42,
    width: 230,
    height: 239.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.239216 0 0 0 0 0.270588 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_832",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSurgeryCostInsurance);
export default __webpack_public_path__ + "static/media/imgSurgeryCostInsurance.67b09f2d599011d7ca8b0d7f5810f9d6.svg";
export { ForwardRef as ReactComponent };